import { render, staticRenderFns } from "./UiTypography.vue?vue&type=template&id=6d907535&scoped=true"
import script from "./UiTypography.vue?vue&type=script&lang=js"
export * from "./UiTypography.vue?vue&type=script&lang=js"
import style0 from "./UiTypography.vue?vue&type=style&index=0&id=6d907535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d907535",
  null
  
)

export default component.exports